import { EmptyState } from "@salesapp/ui";
import type { TimelineEvent } from "../../lib/crmApi";
import { useLocale } from "../../shell/LocaleProvider";

const GUID_RE = /\s*(ID:\s*)?[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;

// Entries logged before codes were guaranteed may carry a raw record GUID; users only know codes.
export function stripGuids(text: string): string {
  return text.replace(GUID_RE, "").trim();
}

function timelineTypeLabel(event: TimelineEvent): string {
  return (event.event_type || "event").replace(/_/g, " ");
}

export function RecordTimeline({
  events,
  emptyTitle,
  emptyDescription,
  limit = 8,
}: {
  events: TimelineEvent[];
  emptyTitle: string;
  emptyDescription: string;
  limit?: number;
}) {
  const { formatDate } = useLocale();
  if (events.length === 0) {
    return <EmptyState title={emptyTitle} description={emptyDescription} />;
  }
  return (
    <div className="crm-timeline">
      {events.slice(0, limit).map((ev, i) => (
        <div key={`${ev.record_id}-${i}`} className="crm-timeline-item">
          <div className="crm-timeline-time">{ev.sort_at ? formatDate(ev.sort_at) : ""}</div>
          <div className="crm-timeline-title">{stripGuids(ev.title || "") || timelineTypeLabel(ev)}</div>
          {ev.description && <div className="crm-timeline-desc">{stripGuids(ev.description)}</div>}
        </div>
      ))}
    </div>
  );
}
